import { controls, currencyToNumber, grouped } from "../../controls";

const rpcf25 = {
  label: "Success Lists",
  starting: true,
  url: "rp101m",
  pageLabel: "Success Lists",
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "general", label: "Taluka", star: true }),
    ...controls.oc({ tab: "general", c: "Taluka", clearData: ['village_code'], placeHolder: "Taluka Code", name: "taluka_code", fastpath: "talukas" }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "taluka_display" }),

    ...controls.displayText({ tab: "general", label: "Village", star: true }),
    ...controls.oc({ tab: "general", c: "Village", sendToServer: { sendData: [{ varname: 'taluka.taluka_uid', value: 'taluka_uid' }] }, placeHolder: "Village Code", name: "village_code", fastpath: "villages" }),
    // ...controls.oc({ tab: "general", c: "Village", placeHolder: "Village Code", name: "village_code", fastpath: "villages" }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "village_display" }),

    ...controls.displayText({ tab: "general", label: "Portal", star: false }),
    ...controls.autoComplete({ tab: "general", name: "portal_scheme_code", width: "col-sm-2", controlType: "PortalScheme" }),
    ...controls.displayText({ tab: "general", label: "" }),

  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Success Lists",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Name",
        accessor: "marathi_name",
        rwidth: "*"
      },
      {
        Header: "Name in bank",
        accessor: "bank_name",
      },
      {
        Header: "Converted",
        accessor: "converted_name",
      },
      {
        Header: "Account Number",
        accessor: "account_number"
      },
      {
        Header: "Amount",
        accessor: "amount"
      },
      {
        Header: "Is Paid",
        accessor: "is_paid",
        type: 'tick'
      },
      {
        Header: "Batch Number",
        accessor: "batch_number"
      }
    ]
  }
};

export default rpcf25;